<template>
    <BaseDialog
        :visible="dialog"
        :type="type"
        :form="form"
        title="události"
        @close="dialog=false"
        @process="processForm"
    >
        <v-text-field
                v-model="form.name"
                type="text"
                label="Jméno události"
                :rules="formRules.name"
        />
        <CzDatePicker v-model="form.startAt" label="Začátek akce" />
        <CzDatePicker v-model="form.endAt" label="Konec akce" />
    </BaseDialog>
</template>

<script>
    import BaseDialogMixin from '../../mixins/BaseDialogMixin'

    export default {
        mixins: [BaseDialogMixin],

        data: () => ({
            form: {
                id: 0,
                name: '',
                startAt: '',
                endAt: '',
            },
            formRules: {
                name: [v => v !== '' || 'Vyplňte hodnotu'],
            }
        }),
    }
</script>
